import { SimpleModal, TextInputField } from '@sequencehq/core-components'
import { FC, useState } from 'react'

export const ContractTagModal: FC<{
  initialValue?: string
  onSubmit: (contractTag: string) => void
  onClose: () => void
}> = ({ initialValue, onSubmit, onClose }) => {
  const [value, setValue] = useState(initialValue ?? '')

  return (
    <SimpleModal
      isOpen
      onClose={onClose}
      variant="dialog"
      title={initialValue ? 'Edit contract tag' : 'Add contract tag'}
      submitButtonText="Save"
      submitDisabled={!value.trim()}
      data-testid="phase.contractTag.modal"
      onSubmit={() => {
        onSubmit(value.trim())
        return true
      }}
    >
      <TextInputField
        value={value}
        onChange={e => setValue(e.target.value)}
        data-testid="phase.contractTag.modal.input"
      />
    </SimpleModal>
  )
}
